import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=e3f7128c&scoped=true&"
import script from "./NavTab.vue?vue&type=script&lang=js&"
export * from "./NavTab.vue?vue&type=script&lang=js&"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=e3f7128c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f7128c",
  null
  
)

export default component.exports